import { useEffect, useState } from "react";
import { KbvPluginService } from "@/services/kbvPluginService";

const useLeagueBySlug = (slug) => {
  const [league, setLeague] = useState(null);
  const [resolvedSlug, setResolvedSlug] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLeague(null);
      setResolvedSlug(null);
      setError(null);
      return undefined;
    }

    let isMounted = true;

    const fetchLeague = async () => {
      setError(null);

      try {
        const data = await KbvPluginService.getLeagueBySlug(slug);

        if (isMounted) {
          setLeague(data);
          setResolvedSlug(slug);
        }
      } catch (err) {
        console.error(err);
        if (isMounted) {
          setError(err);
          setLeague(null);
          setResolvedSlug(slug);
        }
      }
    };

    fetchLeague();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  const loading = !!slug && resolvedSlug !== slug;

  return {
    league: resolvedSlug === slug ? league : null,
    loading,
    error,
  };
};

export default useLeagueBySlug;
